import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/AuthLayout.vue";

// Pages
import Login from "@/pages/Login.vue";

//import middleware
import auth from "@/middleware/auth";

// Resolve views
function page(name) {
  return () =>
    import(
      /* webpackChunkName: "page-[request]" */ /* webpackPrefetch: true */ "@/pages/" +
        name +
        ".vue"
    );
}

let menu = {
  path: "/",
  component: DashboardLayout,
  name: "MainMenu",
  children: [
    {
      path: "/profil",
      name: "Userprofil",
      components: { default: page("UserProfile") },
      meta: { middleware: auth }
    },
    /* --- */
    {
      path: "mitglieder",
      name: "Mitglieder",
      components: { default: page("Members/Members") },
      meta: { middleware: auth }
    },
    {
      path: "nicht-mitglieder",
      name: "Nicht-Mitglieder",
      components: { default: page("Members/NonMembers") },
      meta: { middleware: auth }
    },
    {
      path: "mitglieder/neu",
      name: "Mitglied anlegen",
      components: { default: page("Members/MembersEdit") },
      meta: { middleware: auth }
    },
    {
      path: "nicht-mitglieder/neu",
      name: "Nicht-Mitglied anlegen",
      components: { default: page("Members/NonMembersEdit") },
      meta: { middleware: auth }
    },
    {
      path: "mitglieder/:id",
      name: "Mitglied bearbeiten",
      components: { default: page("Members/MembersEdit") },
      meta: { middleware: auth }
    },
    {
      path: "nicht-mitglieder/:id",
      name: "Nicht-Mitglied bearbeiten",
      components: { default: page("Members/NonMembersEdit") },
      meta: { middleware: auth }
    },
    {
      path: "kontakte",
      name: "Kontakte",
      components: { default: page("Contacts/Contacts") },
      meta: { middleware: auth }
    },
    {
      path: "kontakte/neu",
      name: "Kontakt anlegen",
      components: { default: page("Contacts/Contact") },
      meta: { middleware: auth }
    },
    {
      path: "kontakte/personen/:id",
      name: "Person bearbeiten",
      components: { default: page("Contacts/Contact") },
      meta: { middleware: auth }
    },
    {
      path: "kontakte/organisationen/:id",
      name: "Organisation bearbeiten",
      components: { default: page("Contacts/Contact") },
      meta: { middleware: auth }
    },
    {
      path: "/statistiken/aktuell",
      name: "Aktueller Stand",
      components: { default: page("Statistics/Current") },
      meta: { middleware: auth }
    },
    {
      path: "/statistiken/ab-zugaenge",
      name: "Ab/Zugänge",
      components: { default: page("Statistics/Registrations") },
      meta: { middleware: auth }
    },
    {
      path: "/statistiken/trends-bar",
      name: "Trends - Bar",
      components: { default: page("Statistics/TrendsBar") },
      meta: { middleware: auth }
    },
    {
      path: "/statistiken/trends-line",
      name: "Trends - Line",
      components: { default: page("Statistics/TrendsLine") },
      meta: { middleware: auth }
    },
    /* --- */
    {
      path: "/listen/ansprechpartner",
      name: "Ansprechpartner",
      components: { default: page("Lists/Contacts") },
      meta: { middleware: auth }
    },
    {
      path: "/listen/emails",
      name: "Email",
      components: { default: page("Lists/Emails") },
      meta: { middleware: auth }
    },
    {
      path: "listen/kategorien",
      name: "Kategorien",
      components: { default: page("Lists/Categories") },
      meta: { middleware: auth }
    },
    {
      path: "/listen/services",
      name: "Services-Liste",
      components: { default: page("Lists/Services") },
      meta: { middleware: auth }
    },
    /* --- */
    {
      path: "/rechnungen/liste-ausgang",
      name: "Liste Ausgang",
      components: { default: page("Invoices/List") },
      meta: { middleware: auth }
    },
    {
      path: "/rechnungen/jahresrechnungen",
      name: "Jahresrechnungen",
      components: { default: page("Invoices/Annual") },
      meta: { middleware: auth }
    },
    /* --- */
    {
      path: "/organisation/aufgaben",
      name: "Organisationsaufgaben",
      components: { default: page("Organisation/Tasks") },
      meta: { middleware: auth }
    },
    {
      path: "/organisation/termine",
      name: "Termine",
      components: { default: page("Organisation/Dates") },
      meta: { middleware: auth }
    },
    {
      path: "/organisation/nachrichten",
      name: "Organisationsnachrichten",
      components: { default: page("Organisation/Notifications") },
      meta: { middleware: auth }
    },
    /* --- */
    {
      path: "/einstellungen/verein",
      name: "Verein",
      components: { default: page("Settings/Club") },
      meta: { middleware: auth }
    },
    {
      path: "/einstellungen/benutzerkonten",
      name: "Benutzerkonten",
      components: { default: page("Settings/Users") },
      meta: { middleware: auth }
    },
    {
      path: "/einstellungen/benutzerkonten/neu",
      name: "Benutzerkonto anlegen",
      components: { default: page("Settings/UsersNew") },
      meta: { middleware: auth }
    },
    {
      path: "/einstellungen/benutzerkonten/:id",
      name: "Benutzerkonto bearbeiten",
      components: { default: page("Settings/UsersEdit") },
      meta: { middleware: auth }
    },
    {
      path: "/einstellungen/mitgliedskategorien",
      name: "Mitgliedskategorien",
      components: { default: page("Settings/MemberCategories") },
      meta: { middleware: auth }
    },
    {
      path: "/einstellungen/mitgliedskategorien/neu",
      name: "Mitgliedskategorie anlegen",
      components: { default: page("Settings/MemberCategoriesNew") },
      meta: { middleware: auth }
    },
    {
      path: "/einstellungen/mitgliedskategorien/:id",
      name: "Mitgliedskategorie bearbeiten",
      components: { default: page("Settings/MemberCategoriesEdit") },
      meta: { middleware: auth }
    },
    {
      path: "/einstellungen/services",
      name: "Services",
      components: { default: page("Settings/Services") },
      meta: { middleware: auth }
    },
    {
      path: "/einstellungen/services/:id",
      name: "Service",
      components: { default: page("Settings/Service") },
      meta: { middleware: auth }
    },
    {
      path: "/einstellungen/services/neu",
      name: "Service anlegen",
      components: { default: page("Settings/ServicesNew") },
      meta: { middleware: auth }
    }
  ]
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login
    }
  ]
};

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    name: "Home"
  },
  menu,
  authPages,
  {
    path: "/",
    component: DashboardLayout,
    meta: { middleware: auth },
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        components: { default: page("Dashboard") },
        meta: { middleware: auth }
      }
    ]
  }
];

export default routes;
